import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar1Colors = {
  background?: string;
  skin?: string;
  accessories?: string;
  hair?: string;
};

export const Avatar1 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar1Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    accessories: colors.accessories ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar1">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="Vector"
            d="M103.42 261.967c-12.296 5.129-38.737 14.096-38.84 14.128 24.688 17.362 54.776 27.564 87.253 27.564s62.629-10.226 87.325-27.619c-9.899-8.841-24.362-20.707-35.217-25.167-26.352-10.839-83.669 4.062-100.529 11.094h.008Z"
            fill="#000"
          />
          <Path
            id="skin"
            d="M121.897 220.499c.629 11.245 1.521 26.91.016 29.665-3.552 6.507-18.078 12.138-18.078 12.138s-2.015 36.172 13.897 36.498c26.241 2.469 78.477-47.465 78.477-47.465s-12.965-6.682-15.53-17.194c-1.585-6.507-1.521-31.02-1.768-45.745-.095.151-.199.294-.303.446a101.07 101.07 0 0 0 8.936-16.725c.287.168.589.311.9.422 4.731 1.657 10.974-3.575 13.945-11.675 2.97-8.107 1.537-16.015-3.202-17.672-1.561-.541-2.922-.732-4.149-.621.191-2.206.287-4.388.287-6.53 0-41.055-6.331-69.056-69.566-69.056-35.025 0-39.27 44.311-37.677 81.057 0 13.555-1.704 13.181.048 24.633 12.057 32.915 24.194 46.741 33.751 47.832l.016-.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector_2"
            d="M172.643 131.756s-10.966-3.018-19.52-2.859c-10.058.191-17.21 6.427-19.097 3.313-.606-.995-.112-6.251 18.245-8.211 8.211-.876 12.989 2.581 20.38 7.757h-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            d="M87.874 128.252c22.945-2.628 28.75 5.647 27.452 7.518-.804 1.155-2.779 1.298-4.595-.008-3.815-3.87-10.711-5.622-22.665-3.13-.311-1.322-.216-3.265-.192-4.372v-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            d="M115.327 135.77c.239-.343.231-.908-.072-1.577 8.641 12.535-3.297 32.7 1.362 36.507 3.249 2.66 15.538-1.059 16.015 2.341-4.475 2.859-16.796 5.137-20.523-1.465-1.457-3.409 8.195-26.098-1.378-35.814 1.816 1.306 3.799 1.163 4.596.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_5"
            d="M154.501 228.996c-12.121 10.728-23.971 13.993-31.792 14.845.143-6.291-.398-15.808-.82-23.342.366.04.74.071 1.099.079 13.053.16 28.336-3.679 42.328-16.174 5.097-4.548 9.653-10.003 13.595-16.008 0 .398.016.804.016 1.211-1.959 8.855-7.686 24.568-24.434 39.389h.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="accessories"
            d="M105.117 207.35c-1.378 1.394-3.035 2.206-4.803 2.206-4.842 0-8.768-6.028-8.768-13.459 0-3.536.9-6.753 2.35-9.15a218.784 218.784 0 0 1-4.532-11.03c-3.393 4.754-5.527 11.603-5.527 19.217 0 14.375 7.59 26.018 16.955 26.018 4.157 0 7.972-2.302 10.919-6.124-2.134-1.983-4.341-4.532-6.586-7.686l-.008.008Z"
            fill={c.accessories}
          />
          <G id="Group_2" fill="#000">
            <Path
              id="Vector_6"
              d="M150.066 135.435a14.235 14.235 0 0 1 6.904.86c1.816.701 3.21 1.864 4.556 3.019 1.823 1.274 4.237.788 6.427.533-2.071 1.466-5.129 2.636-7.646 1.378a21.543 21.543 0 0 0-1.752-1.035c.016.183.04.366.04.557 0 3.417-2.835 6.18-6.323 6.18-3.489 0-6.324-2.771-6.324-6.18 0-.278.024-.549.064-.82-2.477 1.147-4.97 2.851-7.709 4.723 2.484-4.293 6.602-8.251 11.771-9.215h-.008Z"
            />
            <Path
              id="Vector_7"
              d="M89.826 141.854c1.346-1.162 2.74-2.325 4.555-3.018 2.214-.868 4.572-1.131 6.905-.86 5.169.964 9.286 4.914 11.771 9.214-1.41-.955-2.748-1.879-4.054-2.7-.239 3.003-2.803 5.368-5.941 5.368-3.297 0-5.965-2.612-5.965-5.829 0-1.092.327-2.111.86-2.979-2.134.239-4.396 1.075-6.913 2.716-2.516 1.258-5.574.087-7.645-1.378 2.19.255 4.603.741 6.427-.534Z"
            />
          </G>
          <Path
            id="Vector_8"
            d="M138.271 186.062c-3.425-.525-6.738-2.612-10.369-2.612-3.632 0-6.626 2.302-6.626 2.302s-2.461-1.88-5.878-1.88c-2.97 0-8.123 5.75-8.123 5.75s5.439 12.711 15.506 12.711c11.571 0 24.927-16.382 24.927-16.382s-6.65.549-9.429.119l-.008-.008Zm-16.772 9.908c-5.209 0-9.701-4.006-12.918-5.965 3.217.963 7.303 1.401 12.519 1.401 11.206 0 20.117-2.301 24.545-4.547-4.428 3.249-12.949 9.111-24.146 9.111Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="accessories_2"
            d="M159.072 53.367s17.019-16.573 33.162-4.978c16.143 11.596 12.034 26.919 12.034 26.919s-13.714-10.433-21.447-15.14c-8.402-5.12-23.757-6.793-23.757-6.793l.008-.008Z"
            fill={c.accessories}
          />
          <G id="hair" fill={c.hair}>
            <Path
              id="hair_2"
              d="M289.045 125.584c-4.333-12.153-26.783-58.71-26.783-58.71s11.468 9.86 17.162 14.606c-12.002-27.11-47.577-71.804-80.898-59.5-9.398 3.473-21.646 22.364-21.646 22.364s.024.032.048.047c4.308-.836 9.525-.159 15.314 3.998 10.258 7.367 12.337 16.223 12.496 21.718.183.032.35.04.486 0 3.814-1.035 32.381 40.847 39.079 64.134 6.706 23.295 6.682 73.524 6.682 73.524l10.847-32.151s8.25 17.616 11.364 29.037c10.314-13.316 9.39-43.293 9.39-43.293l12.145 14.933s1.545-30.446-5.678-50.707h-.008Z"
            />
            <Path
              id="hair_3"
              d="M217.393 105.324c-6.682-29.515-26.202-53.487-80.19-53.487-35.535 0-54.776 47.593-48.779 67.535 10.528-39.008 33.258-34.946 33.258-34.946s-.9-3.17 6.299-12.328c-1.959 4.26-1.855 7.422-1.402 11.317 17.489-.51 45.578 6.642 45.578 6.642s-1.425 9.859.486 15.959c3.353 10.712 5.583 11.253 16.239 13.563-1.163 2.676-2.007 5.471-2.485 8.163 0 0-2.246 13.388-6.3 18.023 4.197-.263 13.523-2.907 14.965-3.186 10.998-.398 9.111 13.913 7.39 18.054-6.673 16.08-14.892 11.5-14.892 11.5s-1.864 4.54-4.365 9.103c-2.787 5.089-6.164 10.433-4.181 14.065 21.224-5.766 45.061-60.447 38.387-89.962l-.008-.015Z"
            />
          </G>
          <Path
            id="accessories_3"
            d="M190.921 162.983c-10.37 0-18.772 12.902-18.772 28.814s8.402 28.813 18.772 28.813c10.369 0 18.771-12.901 18.771-28.813 0-15.912-8.402-28.814-18.771-28.814Zm.525 44.789c-5.36 0-9.708-6.673-9.708-14.908s4.348-14.909 9.708-14.909 9.708 6.674 9.708 14.909-4.348 14.908-9.708 14.908Z"
            fill={c.accessories}
          />
        </G>
      </G>
    </Svg>
  );
};
